export const SET_VIDEO_PROGRESS = 'SET_VIDEO_PROGRESS'

export const setVideoProgress = progress => dispatch =>
  dispatch({
    type: SET_VIDEO_PROGRESS,
    progress,
  })



// WEBPACK FOOTER //
// ./src/modules/video/actions.js